module.exports = __webpack_public_path__ + "img/kimberly-jones.e92a1596.png";